// Preço no Pix online mostrado na vitrine (decisão 0018, spec desconto-pix-vitrine). Mesma conta do checkout
// (api OrderController.createOrder e CheckoutPayment.getDescontoPagamento): desconto sobre os produtos, arredondado em
// centavos. Mudou um lado, mudar o outro.

// Valor do desconto do Pix sobre um valor de produtos (0 sem desconto)
export function descontoNoPix(valor, perc) {
  const percentual = Number(perc) || 0;
  if (percentual <= 0) return 0;
  const cents = Math.round((Number(valor) || 0) * 100);
  return Math.round((cents * percentual) / 100) / 100;
}

// Preço no Pix; null quando não há desconto (a vitrine mostra o preço normal)
export function precoNoPix(valor, perc) {
  const desconto = descontoNoPix(valor, perc);
  if (desconto <= 0) return null;
  return Math.round(((Number(valor) || 0) - desconto) * 100) / 100;
}

// Percentual sem casas desnecessárias ("10", "7,5")
export function formatarPercentual(perc) {
  return parseFloat(Number(perc).toFixed(2)).toString().replace(".", ",");
}
